export const tryExtractPixelProperty = (value?: number | string) => {
  if (value === undefined || value === null) return undefined

  if (typeof value === 'number') return `${value}px`
  if (typeof value === 'string') return value
}
